import axios from "axios";
import { getUserToken } from "../helpers/local_storage_helpers";
import { blogDetailApi, blogPostCRUDApi, blogSocialMediaCRUDApi } from "../constants/apis";

// Get all blog posts
export const getBlogPosts = async (query = "") => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    try {
        const response = await axios.get(
            `${blogPostCRUDApi}${query}`,
            config
        );
        return response;
    } catch (error) {
        console.error("Error fetching blog posts:", error);
        throw error;
    }
};

// Get single blog post
export const getBlogPost = async (id) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    try {
        const response = await axios.get(
            `${blogPostCRUDApi}${id}/`,
            config
        );
        return response;
    } catch (error) {
        console.error("Error fetching blog post:", error);
        throw error;
    }
};

// Get blog post by slug
export const getBlogPostBySlug = async (slug) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    try {
        const response = await axios.get(
            `${blogDetailApi}/${slug}/`,
            config
        );
        return response;
    } catch (error) {
        console.error("Error fetching blog post:", error);
        throw error;
    }
};

// Create blog post
export const createBlogPost = async (data) => {
    const config = {
        headers: {
            // "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    try {
        const response = await axios.post(
            blogPostCRUDApi,
            data,
            config
        );
        return response;
    } catch (error) {
        console.error("Error creating blog post:", error);
        throw error;
    }
};

// Update blog post
export const updateBlogPost = async ({ id, data }) => {
    const config = {
        headers: {
            // "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    try {
        const response = await axios.put(
            `${blogPostCRUDApi}${id}/`,
            data,
            config
        );
        return response;
    } catch (error) {
        console.error("Error updating blog post:", error);
        throw error;
    }
};

// Patch blog post
export const patchBlogPost = async ({ id, data }) => {
    const config = {
        headers: {
            // "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    try {
        const response = await axios.patch(
            `${blogPostCRUDApi}${id}/`,
            data,
            config
        );
        return response;
    } catch (error) {
        console.error("Error patching blog post:", error);
        throw error;
    }
};

// Delete blog post
export const deleteBlogPost = async (id) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    try {
        const response = await axios.delete(
            `${blogPostCRUDApi}${id}/`,
            config
        );
        return response;
    } catch (error) {
        console.error("Error deleting blog post:", error);
        throw error;
    }
};

// Increment views for blog post
export const incrementBlogPostViews = async (id) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    try {
        const response = await axios.post(
            `${blogPostCRUDApi}${id}/increment-views/`,
            {},
            config
        );
        return response;
    } catch (error) {
        console.error("Error incrementing blog post views:", error);
        throw error;
    }
};

export const createSocialMediaForBlogPost = async (data) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    try {
        const response = await axios.post(
            blogSocialMediaCRUDApi,
            data,
            config
        );
        return response;
    } catch (error) {
        console.error("Error creating social media for blog post:", error);
        throw error;
    }
};

export const updateSocialMediaForBlogPost = async ({ id, data }) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    try {
        const response = await axios.patch(
            `${blogSocialMediaCRUDApi}${id}/`,
            data,
            config
        );
        return response;
    } catch (error) {
        console.error("Error updating social media for blog post:", error);
        throw error;
    }
};